import { replaceSpaces } from 'services/utils';

// Every Formik form in this app skips its onBlur handler (so a plain Yup `.required()` doesn't
// paint an error under a field the user hasn't touched yet) by calling `validateField` manually
// instead of spreading `formik.handleBlur`. That manual call used to fire unconditionally, so
// blurring a still-empty field ran the schema's `.required()` rule and showed the error anyway —
// visibly, as a flicker, whenever something else (e.g. switching tabs) clears errors a beat later.
// This wraps that call so it only validates a field that actually has a value, and clears any
// stale error (format error from a previous value) once the field is emptied out.
export const createBlurValidator = (form) => (fieldName) => () => {
  if (form.values?.[fieldName]) {
    form.validateField(fieldName);
  } else if (form.errors?.[fieldName]) {
    form.setFieldError(fieldName, undefined);
  }
};

// An email address can't contain whitespace (it's stripped from the displayed value and from the
// submitted one anyway), so keep it out of the Formik value itself. Otherwise typing a lone space
// into an empty field stores ' ' — "not empty" to createBlurValidator above, so blurring ran
// `.required()` (after Yup's `.trim()`) and showed "cannot be empty" for a field the user never
// actually typed into.
export const createNoSpacesChangeHandler = (form) => (e) => {
  form.setFieldValue(e.target.name, replaceSpaces(e.target.value));
};
